// start:ng42.barrel
import './time-slotted-event-picker.directive';
// end:ng42.barrel

